import { createContext, useContext } from "react";

import type { ProjectCustomization } from "@/customization/project_customization";

export const project_customization_context =
  createContext<ProjectCustomization | null>(null);

// 项目函数命名统一 snake_case，因此此处不采用 React 常见的 useXxx 命名。
export function use_project_customization(): ProjectCustomization {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const customization = useContext(project_customization_context);
  if (!customization) {
    throw new Error("项目定制脚本尚未初始化");
  }
  return customization;
}
